export default {
  haulers: 'Превозвачи',
  setup: 'Настройки',
  driverExperience: 'Опит на водача',
  users: 'Потребители',
};
